import { CatchBoundary, Outlet } from '@tanstack/react-router';
import { ReactElement, Suspense, useEffect, useState } from 'react';
import { UserProvider } from '../providers/users';
import { Loader } from '@sc/shared-ui';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { BreadCrumbProvider } from '../providers/breadcrumbs';
import { Error } from './Error';

export const Authenticated = (): ReactElement => {
  const [collapsed, setCollapsed] = useState(
    !!localStorage.getItem('sc-menu-collapsed')
  );

  useEffect(() => {
    if (collapsed) {
      localStorage.setItem('sc-menu-collapsed', '1');
    } else {
      localStorage.removeItem('sc-menu-collapsed');
    }
  }, [collapsed]);

  const [resetKey, setResetKey] = useState(String(Math.random())); 

  return (
    <CatchBoundary
      getResetKey={() => resetKey}
      errorComponent={err => <Error setResetKey={setResetKey} {...err} />}
    >
      <Suspense
        fallback={
          <div className="flex items-center justify-center h-full w-full">
            <Loader />
          </div>
        }
      >
        <UserProvider>
          <BreadCrumbProvider>
            <Sidebar collapsed={collapsed} />
            <div className="w-full h-full overflow-hidden flex flex-col">
              <Topbar collapsed={collapsed} setCollapsed={setCollapsed} />
              <div className="overflow-y-auto grow flex flex-col">
                <Outlet />
              </div>
            </div>
          </BreadCrumbProvider>
        </UserProvider>
      </Suspense>
    </CatchBoundary>
  );
};
